export type PaymentMethodKey = "ach" | "fedwire" | "swift";

export const PAYMENT_METHOD_KEYS: ReadonlyArray<PaymentMethodKey> = ["ach", "fedwire", "swift"];

export const isPaymentMethodKey = (val: string): val is PaymentMethodKey =>
  (PAYMENT_METHOD_KEYS as ReadonlyArray<string>).includes(val);

export interface PaymentMethodDescriptionContent {
  heading: string;
  body: string;
  internalNote?: string;
}

export const paymentMethodDescriptions: Record<PaymentMethodKey, PaymentMethodDescriptionContent> = {
  ach: {
    heading: "ACH Instructions",
    body: "Transfer of USD funds between two domestic U.S. banks via the ACH network (ACH-enabled routing number required). Please confirm your bank account accepts this payment method.",
  },
  fedwire: {
    heading: "Fedwire Instructions",
    body: "Transfer of funds between two domestic U.S. banks via wire transfer (wire-enabled routing number required).",
    internalNote: "*A SWIFT/BIC code is required for Carry participants receiving non-USD distributions.",
  },
  swift: {
    heading: "International (SWIFT) Instructions",
    body: "Transfer of funds between cross border banks in either USD or other currency via the SWIFT network (SWIFT/BIC code required).",
  },
};

export type PaymentMethodDescriptions = typeof paymentMethodDescriptions;
